<template>
  <nav v-if="$store.getters.isLeft" class="leftnavi show">
    <section>
      <ul id="leftTopMenu">
        <leftMenuItem v-for="item in menulist" :key="item.index" :link="item.link" :param="item.param" :icon="item.icon" :name="item.name" :alarm="item.alarm"/>
      </ul>
    </section>
    <section v-if="isLogin === true && type === 'user'">
      <div class="leftNaviTitle"><span>회원정보</span></div>
      <ul class="profileList">
        <leftMenuItem link="profile" icon="102" name="내 정보"/>
        <leftMenuItem link="alarm" icon="156" name="알림"/>
        <leftMenuItem link="point-total" icon="146" name="포인트"/>
        <leftMenuItem link="publishing-contract" icon="115" name="출판"/>
      </ul>
    </section>
    <section v-if="submenulist.length > 0">
      <ul id="leftSubMenu">
        <leftMenuItem v-for="item in submenulist" :key="item.index" :link="item.link" :icon="item.icon" :name="item.name"/>
        <li class="leftnaviItem">
          <a href="mailto:support@tmeka.com">
            <icon size="small" uicon="106"/>
            <span>문의하기</span>
          </a>
        </li>
      </ul>
    </section>
    <section v-if="isLogin === true && type === 'default'" id="mylibrary">
      <div class="leftNaviTitle"><span>내 책장</span></div>
      <ul class="profileList">
        <leftMenuItem link="latelyPostList" icon="109" name="최근 본 글"/>
        <leftMenuItem link="laterPostList" icon="110" name="나중에 볼 글"/>
        <leftMenuItem link="BooklistInfo" :param="{type: 'read'}" icon="157" name="읽기목록"/>
        <leftMenuItem link="BooklistInfo" :param="{type: 'buy'}" icon="158" name="구매목록"/>
        <!-- <leftMenuItem link="BooklistInfo" :param="{type: 'like'}" icon="112" name="좋아요"/> -->
      </ul>
    </section>
    <section v-else-if="type !== 'login' && isLogin === false" class="leftLogin">
      <span>지금 로그인하여 새로운 작품과<br /> 인기 작가들을 만나보세요</span>
      <Ubutton text="로그인" class="center" size="small" state="active" :round="true" @click.native="$router.push({name: 'login'})"/>
    </section>
    <!-- <section v-if="type === 'default' && isLogin === false" id="vogue">
      <div class="leftNaviTitle"><span>인기 저작공간</span></div>
      <ul>
        <li v-for="vogueitem in vogueitems" :key="vogueitem._id" class="leftnaviItem">
          <router-link :to="{ name: 'workinfo', params: {work: vogueitem._id} }">
            <profile type="small" :src="vogueitem.user.profile"/>
            <span>{{ vogueitem.name }}</span>
          </router-link>
        </li>
      </ul>
    </section> -->
    <!-- <section v-if="isLogin === true && type === 'default'" id="subscribe">
      <div class="leftNaviTitle"><span>구독</span></div>
      <ul>
        <li class="leftnaviItem" v-for="(item, index) in $store.getters.subscribe" :key="index">
          <router-link v-if="!(item.workuser.state & State.ADMIN) && !(item.work.state & State.ADMIN) && !(item.work.state & State.VISIBLE)" :to="{ name: 'workinfo', params: {work: item.work._id} }">
            <Profile class="img" size="small" :src="item.workuser.profile"/>
            <div class="info">
              <li>
                <span class="title">{{ item.work.name }}</span>
              </li>
            </div>
          </router-link>
          <router-link v-else :to="{ name: 'subscribe', params: {user: $store.getters.id} }">
            <Profile class="img" size="small" src="/s3/icon/icon_profile.jpeg"/>
            <div class="info">
              <li>
                <span class="title">비공개</span>
              </li>
            </div>
          </router-link>
        </li>
      </ul>
    </section> -->
    <section v-if="type === 'edit'" id="genre" class="showBlockContent">
      <ul>
        <leftMenuItem link="edit:step" :param="{target: 0}" icon="137" name="STEP.01 글 정보 입력하기"/>
        <leftMenuItem link="edit:step" :param="{target: 1}" icon="113" name="STEP.02 글쓰기"/>
      </ul>
    </section>
    <section v-if="type !== 'login' && type !== 'user' && type !== 'secession'">
      <ul>
        <leftMenuItem :link="isLogin ? 'profile' : 'login'" icon="108" name="설정"/>
        <leftMenuItem link="mailto" icon="106" name="문의"/>
      </ul>
    </section>
    <section v-else-if="type !== 'user'">
      <ul>
        <div class="leftNaviTitle"><span>회원탈퇴</span></div>
        <leftMenuItem link="secession" icon="115" :name="isLogin ? '탈퇴 동의 및 약관확인' : '탈퇴 철회 및 안내확인'"/>
      </ul>
    </section>
    <!-- <article id="admin">
      <ul>
        <li><a href="/admin/member"><span class="smallIcon setting"></span><span>관리하기</span></a></li>
      </ul>
    </article> -->
    <footer v-if="$store.getters.ui === 0">
      <!-- <button onclick="temaChange()">테마변경</button> -->
      <p>
        <span>스담 | 대표 이민정</span>
        <span>사업자등록번호 884-62-00202</span>
        <span>통신판매업 : 제 2020-서울관악-2760호 <br />서울특별시 관악구 남부순환로 1861</span>
        <span>전화 : 070-4252-8887</span>
        <span>고객센터 : support@tmeka.com</span>
      </p>
      <p>
        <Ubutton type="text" text="이용약관" @click="$router.push({name: 'terms-service'})"/>
        <Ubutton type="text" text="개인정보 취급방침" @click="$router.push({name: 'terms-personal'})"/>
      </p>
      <p>
        <span>© 2018 유펜비, LLC</span>
      </p>
      <!-- <div>
        <p>
          <a href="#">정보</a> <a href="#">프레스</a> <a href="#">저작권</a><br>
          <a href="#">이용약관</a> <a href="#">개인정보 보호</a><br>
          <a href="#">정책 및 안전</a><br><br>
        </p>
        <p>
          <span>© 2018 스담, LLC</span>
        </p>
      </div> -->
    </footer>
  </nav>
</template>

<script>
import {State} from '@/components/js/Utils'

export default {
  props: {},
  name: 'TmekaLeft',
  created () {
    this.changeType()
  },
  mounted () {
    console.log(this.$store)
  },
  data () {
    return {
      State: State,
      vogueitems: [],
      subscribe: [],
      isSubscribeShow: false,
      type: ''
    }
  },
  watch: {
    '$route': 'changeType',
    type (val) {
      console.log(val)
      switch (this.$store.getters.auth) {
        case 'admin':
        case 'drive':
          break
        default:
          if (this.$route.name !== null) {
            if (this.isLogin) {
              this.$store.dispatch('subscribe')
              this.$store.dispatch('issubscribe')
              // this.$http.post('/api/library/getSubscribeList').then((e) => {
              //   console.log('getSubscribeList', e)
              //   if (e.success) {
              //     this.subscribe = e.data
              //   }
              // })
            } else {
              if (!this.vogueitems.length) {
                this.$http.post('/api/library/popularWork').then((row) => {
                  console.log('popularWork', row)
                  if (row.success) {
                    this.vogueitems = row.data
                  } else {
                  }
                })
              }
            }
          }
      }
    }
  },
  computed: {
    menulist () {
      var list = []
      if (this.type !== 'secession') {
        list.push({link: 'main', icon: '101', name: '홈'})
      }
      console.log(this.$route)
      var n = (this.$route.matched.length) ? this.$route.matched[0].path : this.$route.name
      switch (n) {
        case '/auth' :
        case '/terms' :
          list.push({link: 'login', icon: '102', name: '로그인'})
          list.push({link: 'join', icon: '103', name: '회원가입'})
          list.push({link: 'accountSearch', icon: '104', name: '계정찾기'})
          break
        case '/secession' :
          break
        default :
          if (this.isLogin) {
            list.push({link: 'subscribe', param: {user: this.$store.getters.id}, icon: '129', name: '구독', alarm: this.$store.getters.issubscribe})
            list.push({link: 'worklist', param: {user: this.$store.getters.id}, icon: '153', name: '내 서재'})
            list.push({link: 'publishing-contract', param: {user: this.$store.getters.id}, icon: '115', name: '출판 관리'})
          } else {

          }
          break
      }
      return list
    },
    submenulist () {
      switch (this.type) {
        case 'login' :
          return [
            {link: 'terms-company', icon: '000', name: '스담'},
            {link: 'terms-copyright', icon: '000', name: '저작권'},
            {link: 'terms-adultcontent', icon: '000', name: '성인콘텐츠'},
            {link: 'terms-service', icon: '105', name: '이용약관'},
            {link: 'terms-paidservie', icon: '105', name: '유료서비스이용약관'},
            {link: 'terms-refund', icon: '105', name: '환불약관'},
            {link: 'terms-personal', icon: '105', name: '개인정보취급방침'},
            {link: 'terms-managing', icon: '105', name: '운영원칙'}
          ]
        case 'user' :
          return [
            {link: 'user-terms-company', icon: '000', name: '스담'},
            {link: 'user-terms-copyright', icon: '000', name: '저작권'},
            {link: 'user-terms-adultcontent', icon: '000', name: '성인콘텐츠'},
            {link: 'user-terms-service', icon: '105', name: '이용약관'},
            {link: 'user-terms-paidservie', icon: '105', name: '유료서비스이용약관'},
            {link: 'user-terms-refund', icon: '105', name: '환불약관'},
            {link: 'user-terms-personal', icon: '105', name: '개인정보취급방침'},
            {link: 'user-terms-managing', icon: '105', name: '운영원칙'}
          ]
        default:
          return []
      }
    }
  },
  methods: {
    changeType () {
      console.log(this.$route.matched)
      if (this.$route.matched.length > 0) {
        switch (this.$route.matched[0].path) {
          case '/user' :
            this.type = 'user'
            break
          case '/auth' :
          case '/terms' :
            this.type = 'login'
            break
          default :
            switch (this.$route.name) {
              case 'secession' :
                this.type = 'secession'
                break
              case 'edit' :
              case 'bookedit' :
              case 'categoryedit' :
              case 'workedit' :
              case 'postedit' :
                this.type = 'edit'
                break
              default :
                this.type = 'default'
                break
            }
            break
        }
      } else {
        return 'default'
      }
    }
  },
  components: {
    'leftMenuItem': {
      props: {
        link: {
          type: String,
          required: true
        },
        param: {
          type: Object
        },
        icon: {
          type: String,
          required: true
        },
        name: {
          type: String,
          required: true
        },
        alarm: {
          type: Boolean,
          default: false
        }
      },
      methods: {
        goLink (e) {
          console.log(this.param)
          if (this.$route.name !== this.link || (this.param && this.$route.params.type !== this.param.type)) {
            switch (this.link) {
              case 'mailto' :
                document.location.href = 'mailto:support@tmeka.com'
                break
              case 'edit:step' :
                this.$center.dispatch('tabmove', this.param.target)
                break
              default :
                switch (this.$route.name) {
                  case 'edit' :
                  case 'bookedit' :
                  case 'categoryedit' :
                  case 'workedit' :
                  case 'postedit' :
                    this.confirm({
                      target: '작성중인 글이 있습니다',
                      message: '중단하시고 나가시겠습니까?',
                      icon: '107'
                    }, e => {
                      if (e.result) {
                        this.$router.push({name: this.link, params: this.param})
                      }
                    })
                    console.log(this.$route)
                    break
                  default :
                    this.$router.push({name: this.link, params: this.param})
                    break
                }
                break
            }
          }
        }
      },
      template: '<li class="leftnaviItem" @click="goLink"><icon size="small" :uicon="icon"/><span>{{name}}</span><span v-if="alarm" class="alarm"/></li>'
    }
  }
}
</script>
<style>
nav {
  z-index: 9;
}
.leftnaviItem {
  display: flex;
  position: relative;
  height: 40px;
  min-height: 40px;
  /* height: 100%; */
  width: 100%;
  flex-direction: row;
  align-items: center;
  color: #303030;
  cursor: pointer;
}
.leftnaviItem a {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #303030;
}
.leftnaviItem > span:nth-child(1), .leftnaviItem > a > span:nth-child(1) {
  margin-right: 15px;
  margin-left: 40px;
}
.leftnaviItem:hover { background-color: #EEEEEE; }
.leftnaviItem .alarm {
  position: absolute;
  width: 5px;
  height: 5px;
  top: 3px;
  left: 36px;
  /* top: 50%;
  transform: translateY(-50%);
  left: 33px; */
  display: block;
  background-color: var(--active);
  border-radius: 50%;
  /* margin-left: 10px; */
}
</style>
<style scoped>
.leftnavi::-webkit-scrollbar {width:5px;}
.leftnavi::-webkit-scrollbar-track { background-color: #fFfFfF; }
.leftnavi::-webkit-scrollbar-thumb { background: #DDDDDD }
.leftnavi::-webkit-scrollbar-button { display: none; }
.leftnavi {
  width: 290px;
  height: 100%;
  position: relative;
  overflow-y: scroll;
  background-color: var(--bg-white);
  flex-direction: column;
}
.leftnavi .menu , .leftnavi section{
  width: 100%;
  flex-direction: column;
  /* display: inline-flex; */
  padding: 15px 0px 15px 0px;
  border-bottom: 1px solid #DDDDDD;
}
.leftnavi ul {
  list-style: none;
  display: flex;
  flex-direction: column;
}
.leftNaviTitle{
  display: flex;
  align-items: center;
  height: 35px;
  margin-left: 40px;
}
.leftNaviTitle span{
  display: block;
  text-align: left;
  font-weight: 800;
  color: var(--text-title);
}
.leftLogin {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.leftLogin button {
  margin-top: 30px;
}
.left-fade-enter-active {
  transition: all .3s ease;
}
.left-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.left-fade-enter, .left-fade-leave-to {
  transform: translateX(-290px);
  opacity: 0;
}
footer {
  display: flex;
  flex-direction: column;
  margin: 10px 20px;
  line-height: 1.8em;
  font-size: 0.9em;
}
footer p {
  display: flex;
  flex-direction: column;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Left.vue